/* eslint-disable no-console */
import dayjs from "dayjs";
import { json2csv } from "json-2-csv";
import { client } from "../../../../Utils/axiosClient";
import { exportDriverColumns } from "./data";
import { updateRevenue } from "../../../../Redux/Slices/revenue.slice";
import capitalize from "../../../../Utils/capitalize";

const modified = (data) => {
  if (!data?.length) return [];

  const changed = data?.map((item) => {
    const date = dayjs(item.submittedAt).format("DD-MM-YYYY");

    const distance = item?.distance
      ? parseFloat(item.distance).toFixed(2)
      : null;

    const activity = item?.produceDetails?.reduce((acc, current) => {
      acc += parseFloat(current.amount);
      return acc;
    }, 0);

    const battery = item?.batteryRevenue?.reduce((acc, current) => {
      acc += parseFloat(current?.cost || 0);
      return acc;
    }, 0);

    const combined = parseFloat(activity) - parseFloat(battery);

    const total =
      combined > 0 ? `${parseFloat(combined).toFixed(0)} KSH` : "--";

    return {
      date,
      distance,
      total,
      tripId: item.tripId,
      driverId: item.driverId,
      driverName: `${capitalize(item?.firstName || "")} ${capitalize(
        item?.lastName || "",
      )}`,
    };
  });

  return changed?.length ? changed : [];
};

const handleDriverExport = async ({
  driverIds,
  startDate = "",
  endDate = "",
  dispatch,
  closeDrawer,
}) => {
  try {
    dispatch(
      updateRevenue({
        key: "loading",
        value: true,
      }),
    );

    const localDriverIds = driverIds.join(",");

    const payload = {
      driverIds: localDriverIds,
      startDate: startDate || "",
      endDate: endDate || "",
    };

    const response = await client.post(
      `${process.env.REACT_APP_API_URL}/revenue/export-driver`,
      payload,
    );

    if (response.status === 200) {
      if (!response?.data?.result?.length) {
        closeDrawer();

        dispatch(
          updateRevenue({
            key: "showToastMessage",
            value: {
              visible: true,
              data: {
                title: "No Data Found",
                description: "No data available for selected time period.",
                type: "error",
              },
            },
          }),
        );

        return;
      }

      const updatedData = modified(response?.data?.result);

      const data = json2csv(updatedData, {
        emptyFieldValue: "--",
        keys: exportDriverColumns,
      });

      const blob = new Blob([data], { type: "text/csv;charset=utf-8;" });

      const link = document.createElement("a");

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `${new Date()}.csv`);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      closeDrawer();

      dispatch(
        updateRevenue({
          key: "showToastMessage",
          value: {
            visible: true,
            data: {
              title: "Driver Data Exported.",
              description: "Driver data exported successfully.",
              type: "success",
            },
          },
        }),
      );
    }
  } catch (error) {
    console.log(error);
  } finally {
    dispatch(
      updateRevenue({
        key: "loading",
        value: false,
      }),
    );
  }
};

export default handleDriverExport;
